// src/pages/BnuSamplePage.tsx
import React, { useMemo, useState, useEffect } from "react";
import BnuActivePatientCard from "../../components/Center Admin/Reuse/BnuActivePatientCard";
import { SidebarItem } from "../../components/Center Admin/layout/CenterAppointmentsQueue";
import "../../center admin css/centerAdmin.css";
import CenterAppointmentsQueue from "../../components/Center Admin/layout/CenterAppointmentsQueue";
import api from "../../api/axiosConfig";

// ✅ IMPORT your reusable B&U form
import BUSampleForm from "../../components/Center Admin/forms/BUSampleForm";

export const BnuSamplePage: React.FC = () => {
  const [patient, setPatient] = useState<SidebarItem | null>(null);

  const centerId =
    sessionStorage.getItem("centerId") ||
    localStorage.getItem("centerId") ||
    "";

  const storageKey = "selectedCENTER_ADMIN_B_AND_U_Q";

  // const sessionId =
  //   sessionStorage.getItem("workflowSessionId") ||
  //   sessionStorage.getItem("sessionId") ||
  //   "";

  // --- Load Patient ---
  const loadPatient = () => {
    try {
      const stored = sessionStorage.getItem(storageKey);
      if (stored) {
        const parsed: SidebarItem = JSON.parse(stored);
        setPatient((prev) =>
          JSON.stringify(prev) !== JSON.stringify(parsed) ? parsed : prev,
        );
      } else setPatient(null);
    } catch {
      setPatient(null);
    }
  };

  useEffect(() => {
    loadPatient();
  }, []);

  useEffect(() => {
    const handleStorage = (e: StorageEvent) => {
      // if (e.key === "selectedPatient") loadPatient();
      if (e.key === storageKey) loadPatient();
    };
    const handleCustom = () => loadPatient();

    window.addEventListener("storage", handleStorage);
    window.addEventListener("patientUpdated", handleCustom);

    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("patientUpdated", handleCustom);
    };
  }, []);

  const key = useMemo(
    () => patient?.emrId || patient?.id || "",
    [patient?.emrId, patient?.id],
  );

  const handleBUSampleComplete = async () => {
    try {
      const sessionId = patient?.sessionId;

      if (!sessionId) {
        alert("Session ID missing.");
        return;
      }
      await api.centerworkflowApi.post(
        `/sessions/${encodeURIComponent(
          sessionId,
        )}/center-admin/forms/B_AND_U_SAMPLE/submit`,
        {
          bloodCollected: true,
          urineCollected: true,
          remarks: "Center admin B&U collection",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      sessionStorage.removeItem(storageKey);
      window.dispatchEvent(new Event("patientUpdated"));
    } catch (err) {
      console.error("Workflow submit failed:", err);
      alert("Workflow API failed.");
    }
  };

  return (
    <div className="lab-reports-page" style={{ display: "flex" }}>
      {/* ✅ LEFT QUEUE */}
      <CenterAppointmentsQueue
        centerId={centerId}
        queueApi="CENTER_ADMIN_B_AND_U_Q" // 🔥 THIS IS YOUR API
        activeId={patient?.id}
        onSelect={(id, p) => setPatient(p || null)}
      />

      {/* ✅ RIGHT CONTENT */}
      <div style={{ flex: 1 }}>
        <BnuActivePatientCard patient={patient || undefined} />

        {patient && (
          <BUSampleForm
            emrId={String(patient.emrId)}
            name={patient.name || ""}
            onComplete={handleBUSampleComplete}
          />
        )}
      </div>
    </div>
  );
};

export default BnuSamplePage;
